$(function() {
    var $trigger = $('.check_box[data-target]');

    $trigger.on('click', function(e) {
        var targetSelector = $(this).data('target');
        var $target = $(targetSelector);
        var $checkbox = $target.closest('.form_chk').find('input[type="checkbox"]');

        if ($checkbox.is(':checked')) {
            return;
        }

        $(targetSelector).trigger('click');
    });
});
